// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'antd/dist/reset.css';
import { ConfigProvider } from 'antd';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: '#0288D1', // Couleur principale (bleu)
        colorBgBase: '#fff', // Fond de base
        borderRadius: 8, // Coins arrondis
        fontFamily: "'Inter', sans-serif", // Police moderne
      },
    }}
  >
    <App />
  </ConfigProvider>
);